module.exports = __webpack_public_path__ + "img/line.1afc9218.svg";